import { render, staticRenderFns } from "./financeiro-tabela-regra-gestao.vue?vue&type=template&id=48b1f588"
import script from "./financeiro-tabela-regra-gestao.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-regra-gestao.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-regra-gestao.vue?vue&type=style&index=0&id=48b1f588&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports